export const screeningStatuses = [
  {
    name: 'Identified',
    code: 'IDENTIFIED',
    id: 'IDENTIFIED',
    dropStatus: false
  },
  {
    name: 'Pre-screening',
    code: 'PRE_SCREENING',
    id: 'PRE-SCREENING',
    dropStatus: false
  },
  {
    name: 'Pre-screened',
    code: 'PRE_SCREENED',
    id: 'PRE-SCREENED',
    dropStatus: false
  },
  {
    name: 'Pre-screen Failed',
    code: 'PRE_SCREEN_FAILED',
    id: 'PRE-SCREEN FAILED',
    dropStatus: true
  },
  {
    name: 'Canceled',
    code: 'CANCELED',
    id: 'CANCELED',
    dropStatus: true
  }
];

export const STABLE_COLUMNS = [
  '__check__',
  'fullName',
  'patientId',
  'study',
  'site',
  'patientInclinationScore',
  'patientSource',
  'patientAddedToSsuDate',
  'status',
  'prescreenStatus',
  'idleTime',
  'contactAttempt',
  'contactAttemptsDaysRemaining',
  'prescreenFailedDate',
  'callbackRequestedDateTime',
  'withdrawComment',
  'appointment.date',
  'scheduleAppointment',
  'actions'
];
